<template>
  <div class="collection">
    <div class="collection-header clearfix" v-if="page.total">
      <div class="sorting clearfix">
          <input type="radio" name="sorting" id="sorting1" value="0" v-model="type">
          <label class="form-checked-state f14" for="sorting1">时间</label>
          <input type="radio" name="sorting" id="sorting2" value="1" v-model="type">
          <label class="form-checked-state f14" for="sorting2">作者</label>
          <input type="radio" name="sorting" id="sorting3" value="2" v-model="type">
          <label class="form-checked-state f14" for="sorting3">类型</label>
          <input type="radio" name="sorting" id="sorting4" value="3" v-model="type">
          <label class="form-checked-state f14" for="sorting4">星级</label>
      </div>
      <div class="fr clearfix page-info" v-if="page.totalPage!=1">
        <p class="fl"><span>{{page.curPage}}</span>/{{page.totalPage}}</p>
        <div class="fr page clearfix">
          <a href="javascript:;" class="left" :class="{'disable':page.curPage==1}" @click="pageTurning(type, page.curPage - 1)"><img src="../../images/personal_center/collection-left.png" alt="" /></a>
          <a href="javascript:;" class="right" :class="{'disable':page.curPage==page.totalPage}" @click="pageTurning(type,parseInt(page.curPage) + 1)"><img src="../../images/personal_center/collection-right.png" alt="" /></a>
        </div>
      </div>
    </div>
    <ul class="product-box clearfix" v-if="page.total">
      <li class="product-item"v-for="(item,index) in pro_list">
        <div class="collect-link" @click="collectLink(item)">
          <router-link :to="{path:'/s-mart/application/'+item.app_id+'/detail'}">
            <div class="product-images">
              <img :src="item.feature_logo">
              <div class="product-mask">
              </div>
              <div class="mask">
                <p v-html="item.tip"></p>
              </div>
            </div>
            <div class="product-detail">
              <p class="product-name clearfix">
                <span class="name toe" v-html="item.app_name"></span>
                <span v-if="item.price&&item.money_type==0" class="price" :title="item.price"><i class="fa fa-yen"></i>{{item.price}}</span>
                <span v-if="item.price==0&&item.money_type==0" class="free toe" :title="item.price">免费</span>
                <span v-if="item.money_type==3" class="free toe" :title="item.price">询价</span>
              </p>
              <p class="product-info">
              <span class="user toe">
                <img width="20" height="20" class="avatar" :src="item.user_logo"><span>{{item.nick_name}}</span>
              </span>
              </p>
            </div>
            <div class="product-reback">
            <span class="star" :class="starMap[item.star]">
              <i></i><i></i><i></i><i></i><i></i>
            </span>
              <span class="icon">
              <i class="bk-icon icon-download"></i>{{item.download_num}}
            </span>
              <span class="icon">
              <i class="bk-icon icon-heart"></i>{{item.fan_num}}
            </span>
            </div>
          </router-link>
        </div>
      </li>
    </ul>
    <!-- <ul class="paging" v-if="page.total">
      <li>
        <a href="javascript:;" :class="{'disabled':page.curPage==1}" @click="pageTurning(page.curPage-1)">
          <img src="../../images/personal_center/collection-left.png" alt="" />
        </a>
      </li>
      <li v-for="item in pages" :class="{'active':page.curPage==item,'apostrophe':item=='...'}" @click="pageTurning(item)"><a>{{item}}</a></li>
      <li>
        <a href="javascript:;" :class="{'disabled':page.curPage==page.totalPage}" @click="pageTurning(page.curPage+1)">
          <img src="../../images/personal_center/collection-right.png" alt="" />
        </a>
      </li>
    </ul> -->
    <v-page :page="page" v-if="page.totalPage!=1"></v-page>
    <div class="collection-none" v-if="!page.total">
      <img src="../../images/personal_center/work-null.png" alt="" />
      <p>未收藏任何作品，<router-link to="/s-mart/market">随便逛逛</router-link></p>
    </div>
  </div>
</template>

<script type="text/javascript">
  import vPage from "../page.vue";
  export default{
    components: {
      "v-page" : vPage
    },
    data() {
      return {
        pro_list: [],  // 产品列表
        page: {},      // 页码相关
        pages: [],
        type: 0        // 0 时间  1 作者  2 类型  3 星级
      }
    },
    created() {
      this.starMap = ["","star1","star2","star3","star4","star5"];
      this.$nextTick(() => {
        $(window).scrollTop(0);
        $(".bk-footer").addClass("market");
      });
    },
    watch: {
      "page.curPage": {
        handler: function(curVal, oldVal) {  // 不能使用箭头函数 否则访问不到this
          // if (curVal != 1) {
            this.pageTurning(this.type, curVal);
          // }
        }
      },
      type: {
        handler: function(curVal, oldVal) {
          this.pageTurning(curVal, 1);
        }
      }
    },
    methods:{
      collectLink  (item) {
          if (item.online_status === 'is_publish') {
              let path = '/s-mart/application/'+item.app_id+'/detail';
              this.$router.push({
                  path: path
              });
          } else if(item.online_status === 'is_down'){
              let routeData = this.$router.resolve({
                  name: 'noCollect'
              });
              window.open(routeData.href, '_blank');
          }
      },
      pageTurning(type, curPage) {  // 翻页功能
        let page = this.page;
        if (curPage < 1 || curPage > page.totalPage) {
          return;
        }
        axios.post(myUrl + "sns/collect/product/", qs.stringify({
          page: curPage,
          type: type
        })).then((res) => {
          res = res.data;
          if (res.result) {
            this.page = res.data.page;
            this.page.totalPage = parseInt(this.page.totalPage);
            this.page.curPage = parseInt(this.page.curPage);
            this.pro_list = res.data.items;
          }else {
            console.log(res.message);
          }
        })
      }
    },
    mounted(){
      this.$nextTick(() => {
        this.pageTurning(0,1); // 默认加载第一页 按时间排序
      })
    }
  }
</script>

<style media="screen" lang="scss" type="text/scss">
  .collection{
    /*min-height:500px;*/
    .collection-header{
      padding: 10px 0 18px 0;
      border-bottom: 1px solid #ddd;
      .sorting{
        float: left;
        background: #fff;
        label{
          float:left;
          display: block;
          width: 53px;
          height: 26px;
          border: 1px solid #ddd;
          margin-left: -1px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #a6a6a6;
        }
        label:first-of-type{
          border-radius: 3px 0 0 3px;
        }
        label:last-of-type{
          border-radius: 0 3px 3px 0;
        }
        input{
          display: none;
        }
        input:checked + label{
          background: #57a3f1;
          color: #fff;
          border-color: #57a3f1;
        }
      }
      .page-info{
        p{
          line-height: 26px;
        }
        .page{
          margin-left: 20px;
         a{
          display: block;
          float: left;
          width: 53px;
          height: 26px;
          border: 1px solid #ddd;
          margin-left: -1px;
          line-height: 22px;
          text-align: center;
          background: #fff;
         }
         a.disable{
          background: #f1f1f1;
         }
         a.left{
          border-radius: 3px 0 0 3px;
         }
         a.right{
          border-radius: 0 3px 3px 0;
         }
        }
      }
    }
    .product-box{
      width: 1180px;
      margin: 28px auto 0;
      .product-item:nth-child(4n){
        margin-right: 0;
      }
      .product-item{
        float: left;
        margin: 0 13px 28px 0;
        &:hover{
          box-shadow: 0px 0px 9px rgba(9,11,26,0.1);
          .product-images{
            .product-mask{
              opacity:1;
            }
            .mask{
              top: 0;
            }
          }
        }
        a{
          display: inline-block;
          width: 285px;
          height: 243px;
          .product-images{
            width:285px;
            height:160px;
            position: relative;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
            }
            .product-mask{
              width: 100%;
              height: 100%;
              position: absolute;
              left:0;
              top: 0;
              opacity:0;
              background: rgba(0,0,0,0.46);
              -webkit-transition: all 0.2s ease-out;
              -moz-transition: all 0.2s ease-out;
              -o-transition: all 0.2s ease-out;
              -ms-transition: all 0.2s ease-out;
            }
            .mask{
              position: absolute;
              left:0;
              top: 100%;
              width: 100%;
              height: 100%;
              padding: 19px 15px 0;
              background: #fff;
              font-size: 12px;
              color: #444444;
              margin-top: 109px;
              -webkit-transition: all 0.2s ease-out;
              -moz-transition: all 0.2s ease-out;
              -o-transition: all 0.2s ease-out;
              -ms-transition: all 0.2s ease-out;
              p{
                width: 100%;
                height: 50px;
                line-height: 16px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:2;
                word-break: break-all;
              }
            }
          }
          .product-detail{
            background: #fff;
            height: 83px;
            padding: 15px 14px 0;
            box-shadow: 0px 0px 1px 0 #ccc;
            border-top: 0;
            .product-name{
              color: #4f515e;
              line-height: 20px;
              span{
                float: left;
              }
              .name{
                width: 170px;
              }
              .price{
                float: right;
                font-size: 20px;
                max-width: 85px;
              }
              .free{
                float: right;
                font-size: 18px;
              }
            }
            .product-info{
              margin-top: 10px;
              .user{
                color: #4f515e;
                .avatar{
                  border-radius: 2px;
                  margin-right: 7px;
                }
                .user-name{
                  width: 130px;
                  display: inline-block;
                  vertical-align: middle;
                }
                >img{
                  width: 20px;
                  height: 20px;
                }
              }
              .star{
                float: right;
              }
            }
          }
        }
      }
    }
    .collection-none{
      padding: 46px;
      width: 555px;
      height: 174px;
      background: #fff;
      border-radius: 3px;
      margin: 36px auto;
      text-align: center;
      p{
        margin-top: 25px;
        font-size: 16px;
        color: #878996;
      }
    }
  }
  .product-reback{
    height: 35px;
    background: #fafafa;
    padding: 8px 14px;
    box-shadow: 0px 1px 1px 0 #ccc;
    .icon{
      display: inline-block;
      float: right;
      margin-left: 16px;
      font-size: 12px;
      color: #4f515e;
      .bk-icon {
        display: inline-block;
        margin-right: 6px;
        /* &.icon-heart {
          width: 12px;
          height: 10px;
          background: url(../../images/application_detail/icon-heart2.png) no-repeat;
          background-size: 100% 100%;
        }
        &.icon-download {
          width: 14px;
          height: 12px;
          background: url(../../images/application_detail/icon-download3.png) no-repeat;
        } */
      }
    }
  }

  .product-sold-out{
    background: #f4f4f4;
    padding-top: 50px;
    padding-bottom: 140px;
    margin-top: 60px;
  }

</style>



// WEBPACK FOOTER //
// my_collection.vue?6a451d1e